import "whatwg-fetch"

export class RequestHandler {
  token: string
  url: string
  method: string
  bodyString: string

  constructor(url: string, method: string, body?: object) {
    const tokenMeta: HTMLMetaElement = document.getElementsByName(
      "csrf-token"
    )[0] as HTMLMetaElement
    this.token = tokenMeta.content
    this.url = url
    this.method = method
    if (body) {
      const convertedBody = this.toSnakeCasedObject(body)
      console.log(convertedBody)
      this.bodyString = JSON.stringify(convertedBody)
    }
  }

  toSnakeCasedObject(from: any) {
    if (Array.isArray(from)) {
      return from.map((elem) => this.toSnakeCasedObject(elem))
    }
    if (typeof from != "object" || from == null) {
      return from
    }
    const keys = Object.keys(from)
    const converted = {}
    keys.forEach((k) => {
      converted[this.toSnakeCase(k)] = this.toSnakeCasedObject(from[k])
    })
    return converted
  }

  toSnakeCase(from: string): string {
    return from.replace(/([A-Z])/g, (s) => "_" + s.charAt(0).toLowerCase())
  }

  async request() {
    return await fetch(this.url, {
      method: this.method,
      headers: {
        "X-CSRF-Token": this.token,
        "Content-Type": "application/json; charset=utf-8",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: this.bodyString,
    })
  }
  async requestWithBody() {
    const response = await this.request()
    const json = await response.json()
    return {
      status: response.status,
      body: json,
    }
  }
}
